import { render, staticRenderFns } from "./data_chart.vue?vue&type=template&id=22669f86&scoped=true"
import script from "./data_chart.vue?vue&type=script&lang=js"
export * from "./data_chart.vue?vue&type=script&lang=js"
import style0 from "./data_chart.vue?vue&type=style&index=0&id=22669f86&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22669f86",
  null
  
)

export default component.exports